import { computed, inject, InjectionToken, signal, type Signal } from '@angular/core';

import { environment } from '@env/environment';
import type { FeatureFlags } from '@env/environment.type';

export const FEATURE_FLAGS = new InjectionToken<Signal<FeatureFlags>>('FEATURE_FLAGS', {
  providedIn: 'root',
  factory: () => signal<FeatureFlags>(environment.featureFlags).asReadonly(),
});

export function fleetManagementEnabled(): Signal<boolean> {
  const featureFlags = inject(FEATURE_FLAGS);
  return computed(() => featureFlags().fleetManagement);
}

export function administrationEnabled(): Signal<boolean> {
  const featureFlags = inject(FEATURE_FLAGS);
  return computed(() => featureFlags().administration);
}

export function hasUsableFleets(fleets: Signal<readonly unknown[]>): Signal<boolean> {
  const fleetEnabled = fleetManagementEnabled();
  return computed(() => fleetEnabled() && fleets().length > 0);
}
